export function getPriceInTwoDecimals(price: string | number) {
  return Number(+price / 100).toFixed(2);
}
